import { SpecialNodeTypes } from './consts';
import callOrReturn from '@adsk/bim360-matrix-react-helpers/es/callOrReturn';

const isNodeExpanded = node => node.state && node.state.expanded;
const nodeHasChildren = node =>
  node.state &&
  ((node.state.children && node.state.children.length) ||
    callOrReturn(node.state.hasMoreChildren, {
      availableChildNodes: node.children || [],
      parentNodes: [node].concat(node.parents)
    }) ||
    !node.state.loaded);

const getSpecialChildrenNodes = node => {
  if (!node.state) {
    return [];
  }
  if (node.state.loading) {
    return [{ id: node.id + SpecialNodeTypes.LOADING, type: SpecialNodeTypes.LOADING }];
  }
  if (
    callOrReturn(node.state.hasMoreChildren, {
      availableChildNodes: node.children || [],
      parentNodes: [node].concat(node.parents)
    })
  ) {
    return [{ id: node.id + SpecialNodeTypes.LOAD_MORE, type: SpecialNodeTypes.LOAD_MORE }];
  }

  if (node.state.error) {
    return [{ id: node.id + SpecialNodeTypes.ERROR, type: SpecialNodeTypes.ERROR }];
  }
  return [];
};

export const getFlattenedTree = (nodes, parents = []) =>
  nodes.reduce((flattenedTree, node) => {
    const depth = parents.length;
    const nodeWithHelpers = { ...node, depth, parents };

    if (!nodeHasChildren(node) || !isNodeExpanded(node)) {
      return [...flattenedTree, nodeWithHelpers];
    }

    return [
      ...flattenedTree,
      nodeWithHelpers,
      ...getFlattenedTree(
        [...node.state.children, ...getSpecialChildrenNodes(node)],
        [...parents, node]
      )
    ];
  }, []);
